<template>
  <div>
    <Banner type="info" v-if="!botStudioEnabled">
      <div class="banner-text">Upgrade to make your flows live</div>
      <strong><a id="upgrade-link" class="is-underlined" @click="openUpgradeModal">Upgrade</a></strong>
    </Banner>

    <UpgradeModal v-if="upgradeModalOpen" @close="closeUpgradeModal"></UpgradeModal>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import Banner from '@/shared/components/Banner.vue';
import { BOT_STUDIO_ENABLED } from '@/store/app/featureTypes';
import UpgradeModal from '@/features/bots/components/UpgradeModal.vue';
import { useStore } from 'vuex';

const store = useStore();
const isWorkspaceFeatureEnabled = (feature: string, defaultValue = false) =>
  computed(() => store.getters.isWorkspaceFeatureEnabled(feature, defaultValue));
const upgradeModalOpen = ref(false);

const botStudioEnabled = computed(() => isWorkspaceFeatureEnabled(BOT_STUDIO_ENABLED, true));

function closeUpgradeModal() {
  upgradeModalOpen.value = false;
}

function openUpgradeModal() {
  upgradeModalOpen.value = true;
}
</script>
